import { render } from "./ShareButton.vue?vue&type=template&id=4ef9ab30"
import script from "./ShareButton.vue?vue&type=script&lang=js"
export * from "./ShareButton.vue?vue&type=script&lang=js"
script.render = render

export default script